// src/utils/animations.js
import gsap from 'gsap';
  
// Fade in animation
export const fadeIn = (element, delay = 0, duration = 0.5) => {
  gsap.fromTo(
    element,
    { opacity: 0 },
    { opacity: 1, duration, delay, ease: 'power2.out' }
  );
};

// Slide up animation
export const slideUp = (element, delay = 0, duration = 0.5, y = 50) => {
  gsap.fromTo(
    element,
    { opacity: 0, y },
    { opacity: 1, y: 0, duration, delay, ease: 'power2.out' }
  );
};

// Staggered animation for multiple elements
export const staggerElements = (elements, animation, staggerTime = 0.1) => {
  elements.forEach((element, index) => {
    animation(element, index * staggerTime);
  });
};

// Animate counting for statistics
export const animateCounter = (element, target, duration = 2, delay = 0) => {
  let start = 0;
  const startTime = Date.now();
  
  const updateCounter = () => {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - startTime) / 1000; // in seconds
    
    if (elapsedTime < delay) {
      requestAnimationFrame(updateCounter);
      return;
    }
    
    const progress = Math.min((elapsedTime - delay) / duration, 1);
    const easeProgress = easeOutCubic(progress);
    const currentValue = Math.floor(easeProgress * target);
    
    if (currentValue !== start) {
      element.textContent = currentValue.toLocaleString();
      start = currentValue;
    }
    
    if (progress < 1) {
      requestAnimationFrame(updateCounter);
    } else {
      element.textContent = target.toLocaleString();
    }
  };
  
  requestAnimationFrame(updateCounter);
};

// Easing function for counter animation
function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3);
}